import { Link } from 'react-router-dom';

const facebookUrl = 'https://www.facebook.com/groups/themommymingle';

export default function Footer() {
  return (
    <footer className="bg-stone-50 border-t border-stone-100">
      {/* Partner CTA strip */}
      <div className="bg-gray-900 px-4 py-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-5">
          <div>
            <p className="text-white font-bold text-base leading-snug" style={{ fontFamily: "'Playfair Display', serif" }}>
              Want visibility in front of 3,000+ local moms?
            </p>
            <p className="text-gray-400 text-sm mt-0.5">Local businesses — get featured where moms are actively looking.</p>
          </div>
          <Link
            to="/partner"
            className="shrink-0 inline-flex items-center gap-2 px-7 py-3 bg-rose-500 hover:bg-rose-600 text-white text-sm font-bold rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Apply to be featured
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>
      </div>

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/0b5cbc7d1d3a0b59b4f12d58a349c104/0e9a9094489a9ea77e178b77c480f264.png"
              alt="The Mommy Mingle"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-500 text-sm leading-relaxed mb-2">
              Mix &bull; Mingle &bull; Make Memories
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              Gwinnett County&apos;s community hub for local moms — events, resources, and real connection.
            </p>
            <div className="flex space-x-3">
              <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white border border-gray-200 rounded-full text-gray-500 hover:text-pink-600 hover:border-pink-300 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white border border-gray-200 rounded-full text-gray-500 hover:text-pink-600 hover:border-pink-300 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-gray-900 font-semibold text-sm mb-4 uppercase tracking-wider">Explore</h3>
            <ul className="space-y-2.5">
              <li><a href="https://gwinnettcampguide.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">Seasonal Guides</a></li>
              <li><Link to="/events" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">Events</Link></li>
              <li><Link to="/things-to-do" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">Things To Do</Link></li>
              <li><Link to="/local-resources" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">Local Help</Link></li>
              <li><Link to="/whattheduck" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">What The Duck</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-gray-900 font-semibold text-sm mb-4 uppercase tracking-wider">Community</h3>
            <ul className="space-y-2.5">
              <li>
                <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">
                  Join The Mommy Mingle
                </a>
              </li>
              <li><Link to="/" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">Find Your People</Link></li>
              <li><Link to="/events" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">Submit an Event</Link></li>
              <li><Link to="/partner" className="text-gray-500 text-sm hover:text-pink-600 transition-colors">Partner With Us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-gray-900 font-semibold text-sm mb-4 uppercase tracking-wider">Get in Touch</h3>
            <ul className="space-y-2.5 mb-5">
              <li className="flex items-start text-gray-500 text-sm">
                <i className="ri-map-pin-line text-pink-500 mt-0.5 mr-2 shrink-0" />
                <span>Sugar Hill, Gwinnett County, Georgia</span>
              </li>
              <li className="flex items-start text-gray-500 text-sm">
                <i className="ri-mail-line text-pink-500 mt-0.5 mr-2 shrink-0" />
                <a href="mailto:hello@themommymingle.com" className="hover:text-pink-600 transition-colors">hello@themommymingle.com</a>
              </li>
            </ul>
            <Link
              to="/partner"
              className="inline-flex items-center gap-1.5 text-xs font-bold text-rose-500 hover:text-rose-600 transition-colors"
            >
              Work with us
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; 2025 The Mommy Mingle. All rights reserved. Sugar Hill, GA.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 text-sm hover:text-pink-600 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-400 text-sm hover:text-pink-600 transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
